var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3205",
    "data-name": "Rectangle 3205",
    width: 20,
    height: 20,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_142",
    "data-name": "Mask Group 142",
    clipPath: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(0 3.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M13.333,10.666A2.667,2.667,0,1,1,10.666,8,2.667,2.667,0,0,1,13.333,10.666Z",
    transform: "translate(-0.665 -4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M20.451,9.941a14.123,14.123,0,0,0-4.136-4.189A10.466,10.466,0,0,0,10.652,4,9.981,9.981,0,0,0,5.474,5.5,15.18,15.18,0,0,0,.9,9.924,1.33,1.33,0,0,0,.878,11.4,13.921,13.921,0,0,0,4.972,15.6a10.323,10.323,0,0,0,5.68,1.734,10.516,10.516,0,0,0,5.675-1.738,13.924,13.924,0,0,0,4.128-4.2,1.342,1.342,0,0,0,0-1.448Zm-9.784,4.725a4,4,0,1,1,4-4A4,4,0,0,1,10.666,14.666Z",
    transform: "translate(-0.665 -4)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeWhite);
export default __webpack_public_path__ + "static/media/eye_white.7fd2b2b8df1333c6161feed018108773.svg";
export { ForwardRef as ReactComponent };